

















































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class TextColorController extends Vue 
{
    @Prop() layer! : DateTextLayer;

    private getTextInfo(name : string)
    {
        return this.layer.textInfo[name];
    }

    private changeTextColor(hex : string)
    {
        var hexContent = hex.substr(0, 1) == "#" ? hex.substr(1, 6) : hex; 
        var r = parseInt(hexContent.substr(0, 2), 16);
        var g = parseInt(hexContent.substr(2, 2), 16);
        var b = parseInt(hexContent.substr(4, 2), 16);

        this.changeTextInfo("textColor", new ColorConstruct(r,g,b), true, true);
    }

    private requestColor()
    {
        var textColor = this.getTextInfo("textColor");
        var current = textColor != null ? textColor : new ColorConstruct();
        this.$emit("requestColor", "textColor", current);
    }

    private changeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeTextInfo", propertyName, value, isFinish, isOnce);
    }
}
